<template>
    <div>

    </div>
</template>

<script>
// import axios from 'axios'
export default {
  data () {
    return {
    }
  },
  methods: {
    // logout - deleted the session from redux server and session and local storage
    logout () {
      if (JSON.parse(localStorage.getItem('ssoToken'))) { // if token is generated from SSO server call SSO API
        var header = this
        window.MKCLAPI.logout().then(function () {
          header.$store.dispatch('clearUserData')
          header.$router.push({path: '/advertisement'})
        }).catch(function (err) {
          console.log(err)
        })
      } else { // if token is generated by liveDemy server then call liveDemy api
        this.$store.dispatch('logoutThirdPartyUser').then(res => {
          this.$store.dispatch('clearUserData')
          this.$router.push({path: '/advertisement'})
        }, err => {
          console.log('ERROR_IN_REMOVING_SESSION_OF_THIRD_PARTY_USER : ', err)
        })
      }
    }
  },
  mounted () {
    this.logout()
    /* if (JSON.parse(localStorage.getItem('ssoToken'))) {
      this.logout()
    } else {
      this.$store.dispatch('logoutThirdPartyUser').then(res => {
        this.$store.dispatch('clearUserData')
        this.$router.push({path: '/advertisement'})
      }, err => {
        console.log('ERROR_IN_REMOVING_SESSION_OF_THIRD_PARTY_USER : ', err)
      })
    } */
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/logout/liveDemyLogout.vue?4a830cb2